import { Component } from '@angular/core';

@Component({
  selector: 'app-split-dropdown-date',
  templateUrl: './split-dropdown-date.component.html',
  styleUrls: ['./split-dropdown-date.component.scss']
})
export class SplitDropdownDateComponent {

}
